import { isArray } from "angular";

const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaTextAreaCtrl = function ($scope, $routeParams, dataService) {
    const vm = this;
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    vm.validationPattern = vm.settings.validationRegex;
    vm.isValid = true;
    
    $scope.$watch(() => dataService.data.activeItem, () => {
        vm.data = _.get(dataService.data.activeItem, dataLookUp);
        if(vm.settings.splitArrayIntoLines===true && vm.data && isArray(vm.data)){
            vm.data = vm.data.map(d=>d.replace('\r\n','\r\n\t')).join('\r\n');
        }
    });

    $scope.$watchCollection('vm.data', (newData, oldData) => {
        if (vm.validationPattern) {
            let regex = new RegExp(vm.validationPattern);
            vm.isValid = regex.test(vm.data);
            $scope.$emit('ValidationStatusChanged', {
                controllerName: $scope.vm.settings.dataAt,
                isValid: vm.isValid
            });
            if (!vm.isValid) {
                vm.settings.helpText = vm.settings.validationMessage;
            } else {
                vm.settings.helpText = null;
            }
        }

        if (newData !== oldData) {
            _.set(dataService.data.activeItem, dataLookUp, newData);
        }
    });
};

lbaTextAreaCtrl.$inject = $inject;

export default lbaTextAreaCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTextArea/lbaTextAreaCtrl.js